/** Static portfolio copy used by the LLM knowledge builder. */
export const PORTFOLIO_PROFILE = {
  name: "Mark Jones Solano",
  title: "Senior Full-Stack Software Engineer",
  location: "Philippines",
  yearsExperience: "8+",
  pitch:
    "I build scalable, production-grade systems end to end for remote teams — UI, backend services, databases, and cloud infrastructure shipped as one cohesive product.",
  subtitle:
    "8+ years across the full stack with distributed teams in the Philippines, US, and EU — from requirements and architecture through implementation, testing, and production releases.",
};

export const PORTFOLIO_INTRODUCTION = [
  `Hello there! I'm Mark Jones Solano — a thoughtful, driven, and genuinely curious person based in the Philippines. People who work with me often describe me as reliable, adaptable, and easy to collaborate with. I care about doing good work without losing the human side of it: listening well, communicating clearly, and showing up for the team even when the problem is messy.`,
  `By profession I'm a Senior Software Engineer and tech solutionist. Over 8+ years I've grown from someone who simply loved fixing things into someone who takes ownership, mentors others, and stays calm under pressure. I'm passionate about learning, honest in how I give feedback, and happiest when I can help turn a vague idea into something real that others can trust and use.`,
  `Life isn't all screens and stand-ups. When I'm off the clock you'll usually find me on the open road with my motorcycle, behind a camera chasing a good landscape, laughing with friends and family, reading something new, or unwinding with a game. Those hobbies keep me grounded, creative, and reminded that balance is part of being at my best — at work and everywhere else.`,
];

export const PORTFOLIO_TECHNOLOGIES = [
  "TypeScript / JavaScript",
  "React / Next.js / Remix",
  "Angular / Vue",
  "Node.js / REST APIs",
  "AWS (EC2, S3, Lambda)",
  "CI/CD & Azure DevOps",
  "Docker",
  "Tailwind CSS / MUI",
  "MongoDB / MySQL",
  "System Design",
  "WCAG Accessibility",
  "Agile / Scrum",
];

export const PORTFOLIO_CONTACT = {
  email: "support@mjsolano.com",
  website: "https://mjsolano.com",
  github: "https://github.com/mjsol12",
  linkedin: "https://www.linkedin.com/in/mark-jones-solano-b17624147",
};
